import React from 'react';
import { TabSwitcher } from 'components';
import { goalDataTypeEnums } from 'utils';

export const correctIncorrectStatuses = [
    { title: 'Correct', tabValue: '1' },
    { title: 'Incorrect', tabValue: '0' },
];

export const timeTypeEnums = {
    MINUTE: 'MINUTE',
    SECUND: 'SECUND',
};

export const renderOptionField = (type, inputs, handleChange, error) => {
    const { value, timeType } = inputs;

    if (type?.dataType === goalDataTypeEnums?.PERCENT) {
        return (
            <TabSwitcher
                tab={value + ''}
                setTab={(tab) => handleChange && handleChange({ target: { name: 'value', value: tab } })}
                list={correctIncorrectStatuses}
                defaultType={'1'}
            />
        );
    }

    if (type?.dataType === goalDataTypeEnums?.RATING) {
        return (
            <input
                disabled={!handleChange}
                onChange={handleChange}
                value={value}
                type="number"
                name={'value'}
                className="target-option-value-input"
                style={{
                    outline: 'none',
                    borderRadius: '4px',
                    border: `1px solid ${error === 'value' ? '#FE7070' : '#E4E7EC'}`,
                }}
            />
        );
    }

    if (
        type?.dataType === goalDataTypeEnums?.WHOLE_INTERVAL ||
        type?.dataType === goalDataTypeEnums?.PARTIAL_INTERVAL ||
        type?.dataType === goalDataTypeEnums?.MOMENTARY_TIME_SAMPLING ||
        type?.dataType === goalDataTypeEnums?.LATENCY
    ) {
        return (
            <div className="target-option-minute-value-box">
                <input
                    disabled={!handleChange}
                    onChange={handleChange}
                    value={handleChange ? value : timeType === timeTypeEnums.MINUTE ? value / 60 : value}
                    type="number"
                    name={'value'}
                    style={{
                        outline: 'none',
                        borderRadius: '4px 0  0 4px',
                        border: `1px solid ${error === 'value' ? '#FE7070' : '#E4E7EC'}`,
                    }}
                />
                <div>
                    <select disabled={!handleChange} onChange={handleChange} value={timeType} style={{ all: 'unset' }} name="timeType">
                        <option value={timeTypeEnums.MINUTE}>Min</option>
                        <option value={timeTypeEnums.SECUND}>Sec</option>
                    </select>
                </div>
            </div>
        );
    }
    // if(type?.dataType === goalDataTypeEnums?.LATENCY){
    //     return (
    //         <div className="target-option-minute-value-box">
    //             <input
    //                 disabled={!handleChange}
    //                 onChange={handleChange}
    //                 value={value}
    //                 style={{
    //                     border: `1px solid ${error === 'value' ? '#FE7070' : '#E4E7EC'}`,
    //                 }}
    //                 type="number"
    //                 name={'value'}
    //             />
    //             <div>
    //                 <p>s</p>
    //             </div>
    //         </div>
    //     )
    // }
};
